module.exports = __webpack_public_path__ + "static/media/hipercard.d9466511.png";